import {
    MDBAlert, MDBBreadcrumb, MDBBreadcrumbItem, MDBBtn, MDBCol, MDBScrollspy, MDBScrollspyLink, MDBSpinner, MDBTabs, MDBTabsContent, MDBTabsItem,
    MDBTabsLink, MDBTabsPane
} from 'mdb-react-ui-kit';
import React, { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import { get911SpecificLocationData, getAddLocationMisc, updateNineOOLocations } from "../apiclients/streamsapi_bridge";
import Body from "../components/body/BodyPage";
import LocEmerNineOO from "../components/editviews/location/LocEmerNineOO";
import LocNineOOContacts from "../components/editviews/location/LocNineOOContacts";
import LocNineOODevices from "../components/editviews/location/LocNineOODevices";
import LocNineOOGeneral from "../components/editviews/location/LocNineOOGeneral";
import MainLinks from "../components/navlinks/MainLinks";
import SaveChanges from "../components/topviews/saveCancel";
import { useAdminContext } from '../components/adminstore/Admin-Context';
import EditWarning from '../components/header/EditWarning';


function Location911OnlySettings(props) {
    const [basicActive, setBasicActive] = useState('tab1');
    const { isEdited, setEdited } = useAdminContext();
    const [targetView, setTargetView] = useState("");
    const [showWarning, setShowWarning] = useState(false);
    const navigate = useNavigate();
    const warningToggle = () => setShowWarning(!showWarning);
    const [failedError, setFailedError] = useState("");

    const handleBasicClick = (value) => {
        if (value === basicActive) {
            return;
        }
        if (isEdited) {
            setTargetView(value);
            setShowWarning(true);
            return;
        }

        setBasicActive(value);
    };

    const handleOk = () => {
        setEdited(false);
        reset();
        if (targetView.indexOf("/") !== -1) {
            const targetValues = targetView.split("#")
            if (targetValues.length > 2) {
                navigate(targetValues[0],
                    {
                        state: { tab: targetValues[1], tab1: targetValues[2] },
                    }
                );

            } else if (targetValues.length > 1) {
                navigate(targetValues[0],
                    {
                        state: { tab: targetValues[1] },
                    }
                );


            } else {
                navigate(targetValues[0]);
            }

        } else {
            setBasicActive(targetView);
        }
        setShowWarning(false);
    };

    const [verticalActive, setVerticalActive] = useState('tab1');
    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }
        setVerticalActive(value);
    };
    const [selectedRegion, setSelectedRegion] = useState("IN");
    const { t, i18n } = useTranslation();
    const [devicesList, setDevicesList] = useState([]);
    const location = useLocation();
    const stateData = location?.state;

    const [nineOOLoc, setNineOOLoc] = useState(
        location.state ? location.state.info ? location.state.info : stateData?.currentLoc ?? location.state : {}
    );
    const [nextLoc, setnextLoc] = useState(stateData?.nextLoc ?? null);
    const [prevLoc, setprevLoc] = useState(stateData?.previousLoc ?? null);
    const [locList, setlocList] = useState(stateData?.locationList ?? []);
    const [successMessage, setSuccessMessage] = useState("");
    const [rerender, setReRender] = useState(false);
    const [defaultValuess, setDefaultValuess] = useState({});
    const [dedicatedNineOneNumbers, setDedicatedNineOneNumbers] = useState([]);
    const [billingGroups, setBillingGroups] = useState([]);
    const [locationsList, setLocationsList] = useState([]);
    const [internalError, setInternalError] = useState(false);
    const [isloading, setIsLoading] = useState(false);
    const [locName, setlocName] = useState("");
    const [locAddress, setlocAddress] = useState("");
    const [stateList, setStateList] = useState([]);
    const [dedlicatedselectedNumber, setdedlicatedselectedNumber] = useState("");


    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    const modifytheState = (e, locObj) => {
        e.preventDefault();
        const currentIndex = locList.findIndex((tmdata) =>
            locObj.is_911 || !locObj.nineoo_loc_id
                ? tmdata.location_id == locObj.location_id && tmdata.location_name == locObj.location_name
                : tmdata.nineoo_loc_id == locObj.nineoo_loc_id && tmdata.nineoo_loc_name == locObj.nineoo_loc_name
        );
        const previousLoc = currentIndex > 0 ? locList[currentIndex - 1] : null;
        const nextLoc = currentIndex < locList.length - 1 ? locList[currentIndex + 1] : null;

        const combinedData = {
            currentLoc: locObj,
            previousLoc,
            nextLoc,
            locationList: locList
        };

        // Navigate based on 911 flag
        if (locObj.is_911 || locObj.nineoo_loc_id) {
            // Update state if staying on same page
            setNineOOLoc(locObj);
            setprevLoc(previousLoc);
            setnextLoc(nextLoc);


        } else {
            navigate("/locDetails", {
                state: combinedData,
            });

        }
    };

    async function get911SpecificLocation() {
        try {

            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            //alert(nineOOLoc.loc_id);
            setIsLoading(true);
            const serverResponsedata = await get911SpecificLocationData(siteid, (nineOOLoc.is_911 ? nineOOLoc.location_id : nineOOLoc.nineoo_loc_id));
            setIsLoading(false);
            if (!serverResponsedata.ok) {
                console.log("Network response was not ok");
                throw new Error('Network response was not ok');
            }
            else {
                const data = await serverResponsedata.json();
                if (data.status == "success") {
                    console.log("data ::::: " + JSON.stringify(data));
                    let devicesData = data.nineoo_loc_details?.devices;
                    if (devicesData?.length > 0) {
                        //alert(JSON.stringify(devicesData));
                        setDevicesList(devicesData)
                    }
                    let { nineoo_loc_name, street_addr1, street_addr2, city, zip, state_name } = data?.nineoo_loc_details?.general ?? {};
                    setlocName(nineoo_loc_name);
                    setlocAddress(street_addr1 + ", " + (street_addr2 ? (street_addr2 + ", ") : "") + city + ", " + (state_name ? (state_name + ", ") : "") + zip);
                    // setdedlicatedselectedNumber(data?.nineoo_loc_details?.emergency_nine_oo?.dedicated_nine_one_one_number ?? "");
                    setDefaultValuess({
                        general: {
                            nineoo_loc_name: data?.nineoo_loc_details?.general.nineoo_loc_name ?? "",
                            street_addr1: data?.nineoo_loc_details?.general?.street_addr1 ?? "",
                            street_addr2: data?.nineoo_loc_details?.general?.street_addr2 ?? "",
                            city: data?.nineoo_loc_details?.general?.city ?? "",
                            state: data?.nineoo_loc_details?.general?.state ?? 0,
                            zip: data?.nineoo_loc_details?.general?.zip ?? 0,
                            billing_grp: data?.nineoo_loc_details?.general?.billing_grp ?? 0
                        },
                        primary_contact: {
                            fname: data.nineoo_loc_details.contacts.fname ?? "",
                            lname: data.nineoo_loc_details.contacts.lname ?? "",
                            email: data.nineoo_loc_details.contacts.email ?? "",
                            number: data.nineoo_loc_details.contacts.number ?? "",
                            additional_emails: data.nineoo_loc_details.contacts?.notification_email ?? ""

                        },
                        nine_one_one: {
                            dedicated_nine_one_one_number: data?.nineoo_loc_details?.emergency_nine_oo?.dedicated_nine_one_one_number ?? "",
                            specific_location: data?.nineoo_loc_details?.emergency_nine_oo?.specific_location ?? "",
                        }
                    });
                }
            }
        } catch (error) {
            console.error("[get911SpecificLocation] Error:", error);
            // Handle the error, show a user-friendly message or log it.
        }
    }

    async function fetch911LocationMisc() {
        try {
            let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
            const params = {
                "misc": [
                    "add_location"
                ],
                "loc_id": (nineOOLoc.is_911 ? nineOOLoc.location_id : nineOOLoc.nineoo_loc_id)
            };

            const serverResponse = await getAddLocationMisc(params, siteid);
            if (!serverResponse.ok) {
                console.log("Network response was not ok");
                throw new Error('Network response was not ok');
            }
            else {
                const tdata = await serverResponse.json();
                console.log("Response Data:", JSON.stringify(tdata));
                // Process and set state based on responseData
                setDedicatedNineOneNumbers(tdata?.misc?.add_location?.dedicated_nine_one_one_number ?? []);
                const transformedBillingGroups = (
                    tdata.misc.add_location.billing_grp || []
                ).map((entry) => ({ text: entry.groupname, value: entry.groupid }));
                setBillingGroups(transformedBillingGroups);
                setStateList(tdata?.misc?.add_location?.state || []);
                const transformedLocationsList = (tdata?.misc?.add_location?.state || []).map(locations => ({ text: locations.statename, value: locations.stateid }));
                setLocationsList(transformedLocationsList);


            }

        } catch (error) {
            console.error("[fetch911LocationMisc] Error:", error);
            // Handle the error, show a user-friendly message or log it.
        }
    }

    useEffect(() => {
        if (nineOOLoc && ((nineOOLoc.nineoo_loc_id && nineOOLoc.nineoo_loc_id != "") || (nineOOLoc.location_id && nineOOLoc.location_id != "")) || rerender) {
            get911SpecificLocation();
            setReRender(false);
        }
    }, [nineOOLoc, rerender]);

    useEffect(() => {
        if (Object.keys(defaultValuess).length !== 0) reset(defaultValuess);
    }, [defaultValuess]);

    useEffect(() => {
        fetch911LocationMisc();
    }, []);

    const { register, reset, getValues, setValue, handleSubmit, formState: { isDirty, errors, dirtyFields }, setError, watch, clearErrors } = useForm({
        defaultValues: {
            general: {
                nineoo_loc_name: "",
                street_addr1: "",
                street_addr2: "",
                city: "",
                state: 0,
                zip: 0,
                billing_grp: 0
            },
            primary_contact: {
                fname: "",
                lname: "",
                email: "",
                number: "",
                additional_emails: ""

            },
            nine_one_one: {
                dedicated_nine_one_one_number: "",
                specific_location: "",
            }

        }
    });

    const onCloseChanges = () => {
        reset();
    };

    const isModified =
        Object.keys(dirtyFields).length > 0 ? true : false;

    useEffect(() => {
        setEdited(isModified);
    }, [isModified])

    const onSaveChanges = async (data) => {
        try {
            const modifiedData = extractModifiedFields(data, dirtyFields);
            if (modifiedData) {
                modifiedData.reqid = 57;
                modifiedData.siteid = JSON.parse(
                    sessionStorage.getItem("admin_session")
                ).siteid;
                modifiedData.nineoo_loc_id = nineOOLoc.nineoo_loc_id ?? nineOOLoc.location_id;
                console.log(
                    "911 location Edit feild json ::: " + JSON.stringify(modifiedData)
                );
                //alert(JSON.stringify(modifiedData));
                setIsLoading(true);
                let response = await updateNineOOLocations(modifiedData);
                setIsLoading(false);
                console.log("response before::::: " + JSON.stringify(response));
                let resdata = await response.json();
                console.log("response ::::: " + JSON.stringify(resdata));
                if (response.status === 200) {
                    //setReRender(false);
                    setSuccessMessage(resdata.message); // success pop up message.
                    setReRender(true); // Re- Rednering the child componenet in order to stay in the same page after saving with latest updated data.
                } else if (response.status === 400) {
                    if (resdata.message?.errors) {
                        resdata.message.errors.forEach((err) => {
                            setError(err.param_name, {
                                type: "server",
                                message: err.message,
                            });
                        });
                    }
                } else if (response.status === 500) {
                    setInternalError(true);
                    setFailedError(resdata?.message ?? "");
                    setReRender(true);
                }
            }
        } catch (e) {
            console.log(`Unable to send update Hunt User to API:${e}`);
            setInternalError(true);
        }
    };

    function extractModifiedFields(data, dirtyFields, modifiedData = {}) {
        for (const field of Object.keys(dirtyFields)) {
            if (dirtyFields[field] && data.hasOwnProperty(field)) {
                if (typeof data[field] === "object" && !Array.isArray(data[field])) {
                    modifiedData[field] = {};
                    extractModifiedFields(
                        data[field],
                        dirtyFields[field],
                        modifiedData[field]
                    );
                } else {
                    modifiedData[field] = data[field];
                }
            }
        }
        return modifiedData;
    }


    const containerRef = useRef(null);
    const section1 = useRef(null);
    const section2 = useRef(null);
    const section3 = useRef(null);


    useEffect(() => {
        const timeoutId = setTimeout(() => {
            const scrollspyLinks = document.querySelectorAll(".nav-link");
            const lastLink = scrollspyLinks[scrollspyLinks.length - 1];
            const stickyParent = lastLink.closest(".sticky-top");
            if (stickyParent && lastLink.classList.contains("active")) {
                lastLink.classList.remove("active");
                for (let i = 0; i < scrollspyLinks.length; i++) {
                    const firstLink = scrollspyLinks[i];
                    const parent = firstLink.closest(".sticky-top");
                    if (parent) {
                        firstLink.classList.add("active");
                        break;
                    }
                }
            }
        }, 100);
        return () => clearTimeout(timeoutId);
    }, []);



    return (
        <React.Fragment>
            <>
                <MainLinks active={7} />
                <Body tablinks={7}
                    sublink={7}
                    content={
                        <>
                            <section className="mb-3">
                                <div className="card card-height">
                                    <div className="card-header py-3 px-0">
                                        <h5 className="mb-0 ">
                                            <MDBBreadcrumb>
                                                <MDBBreadcrumbItem>
                                                    <a
                                                        onClick={(e) => {
                                                            if (isEdited) {
                                                                if (nineOOLoc.is_911 !== undefined) {
                                                                    setTargetView("/loclanding#location#tab1");

                                                                } else {
                                                                    setTargetView("/loclanding#location#tab2");
                                                                }

                                                                setShowWarning(true);
                                                                return;
                                                            }
                                                            if (nineOOLoc.is_911 !== undefined) {
                                                                navigate("/LocLanding", {
                                                                    state: { tab: "location", tab1: "tab1" },
                                                                });

                                                            } else {
                                                                navigate("/LocLanding", {
                                                                    state: { tab: "location", tab1: "tab2" },
                                                                });
                                                            }
                                                        }} ><strong>{t('locations')}</strong></a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem active>
                                                    <a onClick={(e) => {
                                                        if (isEdited) {
                                                            if (nineOOLoc.is_911 !== undefined) {
                                                                setTargetView("/loclanding#location#tab1");

                                                            } else {
                                                                setTargetView("/LocLanding#location#tab3");
                                                            }
                                                            setShowWarning(true);
                                                            return;
                                                        }
                                                        if (nineOOLoc.is_911 !== undefined) {
                                                            navigate("/LocLanding", {
                                                                state: { tab: "location", tab1: "tab1" },
                                                            });

                                                        } else {
                                                            navigate("/LocLanding", {
                                                                state: { tab: "location", tab1: "tab3" },
                                                            });
                                                        }
                                                    }}><strong>{t('911onlylocations')}</strong></a>
                                                </MDBBreadcrumbItem>
                                                <MDBBreadcrumbItem>
                                                    <a href='#'><strong>{locName}</strong></a>
                                                </MDBBreadcrumbItem>
                                            </MDBBreadcrumb>
                                            <div className="headerbtns">
                                                <div className="customtooltip">
                                                    <MDBBtn
                                                        size="sm"
                                                        color="transparent"
                                                        className={prevLoc != null ? "ms-2 " : "ms-2"}
                                                        disabled={prevLoc == null || prevLoc === ""}
                                                        onClick={(e) => modifytheState(e, prevLoc)}
                                                    >
                                                        <i className="fa fa-chevron-left"></i>
                                                    </MDBBtn>
                                                    {prevLoc != null && prevLoc !== "" && (
                                                        <span className="tooltiptext">
                                                            Previous:
                                                            <br />
                                                            {prevLoc != null
                                                                ? prevLoc.location_name ?? prevLoc.nineoo_loc_name
                                                                : ""}
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="customtooltip">
                                                    <MDBBtn
                                                        size="sm"
                                                        color="transparent"
                                                        className={
                                                            nextLoc != null
                                                                ? "ms-2 active"
                                                                : "ms-2 active"
                                                        }
                                                        disabled={
                                                            nextLoc == null || nextLoc === ""
                                                        }
                                                        onClick={(e) =>
                                                            modifytheState(e, nextLoc)
                                                        }
                                                    >
                                                        <i className="fa fa-chevron-right"></i>
                                                    </MDBBtn>
                                                    {nextLoc != null && nextLoc !== "" && (
                                                        <span className="tooltiptext">
                                                            Next:
                                                            <br />
                                                            {nextLoc != null
                                                                ? nextLoc.location_name ?? nextLoc.nineoo_loc_name
                                                                : ""}
                                                        </span>
                                                    )}
                                                </div>
                                            </div>
                                        </h5>
                                    </div>
                                    {/* <div className="card-header">
                                        &gt; <span className="green-text"></span> &gt; Jerome's Place
                                    </div> */}
                                    <div className="card-body px-0">

                                        <div className="w-100 mb-3">
                                            <h5 className="fw-600 mt-2 mb-0">
                                                {locName}
                                                <p className="mt-1  text-secondary">
                                                    {locAddress}
                                                </p>
                                            </h5>
                                        </div>


                                        <MDBTabs className='mb-3'>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab1')} active={basicActive === 'tab1'}>
                                                    {t("settings")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                            <MDBTabsItem>
                                                <MDBTabsLink onClick={() => handleBasicClick('tab2')} active={basicActive === 'tab2'}>
                                                    {t("devices")}
                                                </MDBTabsLink>
                                            </MDBTabsItem>
                                        </MDBTabs>

                                        <MDBTabsContent >
                                            <MDBTabsPane open={basicActive === 'tab1'}>
                                                {/* Tab 1 content */}
                                                <div className="row">
                                                    <MDBCol
                                                        size="2"
                                                        md="2"
                                                        lg="2"
                                                        sm="12"
                                                        className="col-sm-100 pr-0 leftTabs"
                                                    >


                                                        <MDBScrollspy container={containerRef} offset={450}>
                                                            <MDBScrollspyLink targetRef={section1}>
                                                                {t("general")}
                                                            </MDBScrollspyLink>
                                                            <MDBScrollspyLink targetRef={section2}>
                                                                {t("contacts")}
                                                            </MDBScrollspyLink>
                                                            <MDBScrollspyLink targetRef={section3}>
                                                                {t('emergency911')}
                                                            </MDBScrollspyLink>
                                                        </MDBScrollspy>
                                                    </MDBCol>

                                                    <MDBCol
                                                        size="12"
                                                        md="10"
                                                        sm="12"
                                                        pr-0
                                                        className="col-sm-100 pr-0 leftTabContent"
                                                    >

                                                        <div ref={containerRef} className="scrollspy-example" offset={450}>
                                                            <section ref={section1} id="section-1">
                                                                <LocNineOOGeneral
                                                                    register={register}
                                                                    setValue={setValue}
                                                                    getValues={getValues}
                                                                    errors={errors}
                                                                    billingGroups={billingGroups}
                                                                    locationsList={locationsList}
                                                                    stateList={stateList}
                                                                    watch={watch}
                                                                    clearErrors={clearErrors}

                                                                />
                                                            </section>
                                                            <section ref={section2} id="section-2">
                                                                <LocNineOOContacts
                                                                    register={register}
                                                                    setValue={setValue}
                                                                    getValues={getValues}
                                                                    errors={errors}
                                                                    watch={watch}
                                                                />
                                                            </section>
                                                            <div class="routing-border mt-2"></div>
                                                            <section ref={section3} id="section-3">
                                                                <LocEmerNineOO
                                                                    register={register}
                                                                    setValue={setValue}
                                                                    getValues={getValues}
                                                                    errors={errors}
                                                                    dedicatedNineOneNumbers={dedicatedNineOneNumbers}
                                                                />
                                                            </section>
                                                        </div>

                                                        {isModified && (
                                                            <SaveChanges
                                                                onClose={onCloseChanges}
                                                                isFieldModified={isModified}
                                                                onSave={(e) => {
                                                                    e.preventDefault();
                                                                    handleSubmit(onSaveChanges)();
                                                                }}
                                                            />
                                                        )}

                                                    </MDBCol>
                                                </div>
                                            </MDBTabsPane>

                                            <MDBTabsPane open={basicActive === 'tab2'}>
                                                {/* Tab 2 content */}
                                                <div>
                                                    <LocNineOODevices
                                                        devicesList={devicesList}
                                                        isActive={basicActive === 'tab2'}
                                                    />
                                                </div>
                                            </MDBTabsPane>
                                        </MDBTabsContent>


                                    </div>
                                </div>
                            </section>
                        </>
                    }

                />{/* <Footer /> */}
                {successMessage && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="success"
                        autohide
                        position="bottom-right"
                        delay={10000}
                    >
                        <i className="fas fa-check-circle me-3"></i>
                        <span className="alert-msg">{successMessage}</span>
                    </MDBAlert>
                )}

                {isloading && (
                    <>
                        <div className="loadingclass">
                            <MDBBtn disabled>
                                <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
                                Loading...
                            </MDBBtn>
                        </div>
                    </>
                )}
                {internalError && (
                    <MDBAlert
                        open
                        className="alert-center"
                        color="danger"
                        autohide
                        position="bottom-right"
                        delay={3000}
                        onClose={() => setInternalError(false)}

                    >
                        {failedError ? failedError : "Internal Server Error"}
                    </MDBAlert>
                )}
                {showWarning && (
                    <EditWarning
                        warningToggle={warningToggle}
                        setShowWarning={setShowWarning}
                        onOk={handleOk}
                    />
                )}
            </>
        </React.Fragment >
    );
}

export default Location911OnlySettings;